import type { OngoingDownload } from '@mimir/client-common/model/ongoingDownload';
import { transferrableAttachments } from '@mimir/common/dto/attachmentPrimitives';
import { SidecarKind } from '@mimir/common/dto/storageModel';
import type { ItemArtefact, TransferRequestPostRequestDto} from '@mimir/common/dto/transferRequestDtos';
import { TransferStateDto } from '@mimir/common/dto/transferRequestDtos';
import Axios from 'axios';
import capitalize from 'lodash/capitalize';
import { postTransferRequest } from './api';

export const getSidecarSelectionTypes = (includeNull = true) => {
  const sidecarKinds = Object
    .values(SidecarKind)
    .filter(val => typeof val === 'string')
    .map(val => ({ text: val, value: val }));
  if (!includeNull) return sidecarKinds;

  return [{ text: 'Disabled', value: null }, ...sidecarKinds];
};

export const sendItemToStorage = async (
  storageId: string,
  itemId: string,
  title: string,
  artefact: ItemArtefact
): Promise<OngoingDownload> => {
  const transferRequest: TransferRequestPostRequestDto = {
    artefact,
    itemId,
    title,
    storageId,
    transferState: TransferStateDto.PROGRESSING,
  };
  const cancelTokenSource = Axios.CancelToken.source();
  const posedTransferRequest = await postTransferRequest(transferRequest);
  return {
    ...posedTransferRequest,
    artifactReference: { type: 'ImplicitReference' },
    cancelTokenSource
  };
};

export const getTransferrableAttachmentSelections = () => transferrableAttachments.map(att => ({ label: capitalize(att), value: att }));
